import React, { useEffect, useState } from "react";
import "./App.css";
import Routers from "./Routes";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/customizer/CustomizerProvider";
import { ThemeContextProvider } from "./Context/ThemeContext";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { messaging } from "./Services/firebase";
import { API_URL } from "./Constant";

function App() {
  let isMounted = true;
  // useEffect(() => {
  //   const username = localStorage.getItem("username");
  //   if (username !== null) {
  //     RequestPermission(username);
  //   }
  //   return () => {
  //     isMounted = false;
  //   };
  // }, []);

  // const RequestPermission = async (username) => {
  //   //requesting permission using Notification API
  //   const permission = await Notification.requestPermission();

  //   if (permission === "granted") {
  //     const newSw = await navigator.serviceWorker.register(
  //       `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
  //     );
  //     const token = await getToken(messaging, {
  //       vapidKey: process.env.REACT_APP_VAPID_KEY,
  //       serviceWorkerRegistration: newSw,
  //     });

  //     //We can send token to server
  //     if (token) {
  //       // Send the token to your server
  //       const body = {
  //         registration_tokens: token,
  //         topic: username,
  //       };

  //       const response = await fetch(
  //         `${API_URL}notification/subscribe-tokens/`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(body),
  //         }
  //       );
  //       console.log(response);
  //     } else {
  //       console.log(
  //         "No registration token available. Request permission to generate one."
  //       );
  //     }
  //   }
  //   // } else if (permission === "denied") {
  //   //   alert("You denied for the notification");
  //   // }
  // };

  return (
    <CustomizerProvider>
      <AnimationThemeProvider>
        <ThemeContextProvider>
          <Routers />
        </ThemeContextProvider>
      </AnimationThemeProvider>
    </CustomizerProvider>
  );
}
export default App;
